import { render, staticRenderFns } from "./BTabsParent.vue?vue&type=template&id=bdb12b26&"
import script from "./BTabsParent.vue?vue&type=script&lang=ts&"
export * from "./BTabsParent.vue?vue&type=script&lang=ts&"
import style0 from "./BTabsParent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports